'use client';

import { useEffect } from 'react';

interface FuseTag {
    [x: string]: any;
    que: Function[];
    registerZone: (id: string) => void;
}

declare global {
    interface Window {
        fusetag?: FuseTag;
        objDataLayer?: any;
        DD_RUM?: any;
    }
}

interface adProps {
    id: string;
}

export default function Ad({ id }: adProps) {
    const registerZone = (id: string) => {
        const fusetag = window.fusetag || (window.fusetag = { que: [], registerZone: () => { } });
        fusetag.que.push(() => {
            fusetag.pageInit();
        });
        fusetag.que.push(() => {
            fusetag.registerZone(id);
        });
    };

    useEffect(() => {
        registerZone(id);
    }, []);

    return <div data-testid={`ad-${id}`} id={id} data-fuse={id}></div>;
}
